import React from "react";
import Col from "@prism/col";
import DataPair from "../../common/DataPair";
import {updateLastServiceOdo} from "../../../actions/conditionActions";
import {connect} from "react-redux";
import Input from "@prism/input";


class LastServiceOdo extends React.Component {

    handleChange = (e) => {
        const value = e.target.value;
        const lastServiceOdo = value === "" ? null : parseInt(value) || 0;
        this.props.updateLastServiceOdo(lastServiceOdo);
    };

    render() {

        if(this.props.condition===null) {
            return <></>
        }

        if(this.props.condition && (this.props.condition.serviceRequired === undefined || this.props.condition.serviceRequired === null)) {
            return <></>
        }

        return (
            <Col xs={6} sm={6} md={4} lg={3} xl={3} className='mb-2'>
                <DataPair label="Last Service Odo">
                    <Input
                        type="text"
                        id="last-service-odo"
                        value={this.props.condition.lastServiceOdometer}
                        maxLength={6}
                        onChange={this.handleChange}
                    />
                </DataPair>
            </Col>
        )
    }
}

const matchDispatchToProps = {
    updateLastServiceOdo
};

function mapStateToProps({condition}) {
    return {condition};
}
export default connect(mapStateToProps, matchDispatchToProps)(LastServiceOdo);